var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating"},_vm._l((_vm.max),function(n){return _c('span',{key:n,staticClass:"star-rating__star",class:{ 'star-rating__star--filled': n <= _vm.value },on:{"click":function($event){return _vm.setRating(n)}}},[_vm._v("★")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }